$(document).ready(function(){

    // custom slideshow section
    var $slider = jQuery('.custom-slide-list-slider');
    $slider.slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 800,
        prevArrow: '<button class="slick-prev"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9567 26.1818C13.1753 26.1818 13.3989 26.0939 13.5666 25.9233C13.902 25.5821 13.902 25.0238 13.5666 24.6826L2.0862 13.0043L13.3989 1.49663C13.7343 1.15543 13.7343 0.597103 13.3989 0.255905C13.0635 -0.0852928 12.5146 -0.0852928 12.1792 0.255905L0.251563 12.384C-0.0838544 12.7252 -0.0838544 13.2835 0.251563 13.6247L12.3418 25.9233C12.5146 26.0991 12.7331 26.1818 12.9567 26.1818Z" fill="black"/></svg></button>',
        nextArrow: '<button class="slick-next"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.861432 26.1818C0.642902 26.1818 0.419266 26.0939 0.251556 25.9233C-0.0838604 25.5821 -0.0838604 25.0238 0.251556 24.6826L11.732 13.0043L0.419265 1.49663C0.083847 1.15543 0.083847 0.597103 0.419265 0.255905C0.754683 -0.0852928 1.30355 -0.0852928 1.63897 0.255905L13.5666 12.384C13.902 12.7252 13.902 13.2835 13.5666 13.6247L1.47634 25.9233C1.30355 26.0991 1.08504 26.1818 0.861432 26.1818Z" fill="black"/></svg></button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 749,
                settings: {
                    autoplay: false
                }
            }
        ]
    });

    // testimonial slider
    $(".testimonials-list").slick({
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="prev-arrow"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9567 26.1818C13.1753 26.1818 13.3989 26.0939 13.5666 25.9233C13.902 25.5821 13.902 25.0238 13.5666 24.6826L2.0862 13.0043L13.3989 1.49663C13.7343 1.15543 13.7343 0.597103 13.3989 0.255905C13.0635 -0.0852928 12.5146 -0.0852928 12.1792 0.255905L0.251563 12.384C-0.0838544 12.7252 -0.0838544 13.2835 0.251563 13.6247L12.3418 25.9233C12.5146 26.0991 12.7331 26.1818 12.9567 26.1818Z" fill="black"/></svg></div>',
        nextArrow: '<div class="next-arrow"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.861493 26.1818C0.642963 26.1818 0.419327 26.0939 0.251617 25.9233C-0.0837994 25.5821 -0.0837994 25.0238 0.251617 24.6826L11.732 13.0043L0.419326 1.49663C0.0839081 1.15543 0.0839081 0.597103 0.419326 0.255905C0.754744 -0.0852928 1.30361 -0.0852928 1.63903 0.255905L13.5667 12.384C13.9021 12.7252 13.9021 13.2835 13.5667 13.6247L1.4764 25.9233C1.30361 26.0991 1.0851 26.1818 0.861493 26.1818Z" fill="black"/></svg></div>',
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    autoplay: true,
                    centerPadding: '0px' ,
                    autoplaySpeed: 1000,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.custom-iwt-slide').on('init', function (event, slick) {

        $(slick.$slides).each(function () {
            const video = $(this).find('video').get(0);

            if (video) {
                video.onended = function () {
                    console.log("video ended ✅");
                    this.pause();
                    this.currentTime = 0;
                    this.load();
                };
            }
        });

    }).on('afterChange', function (event, slick, currentSlide) {
        // reset ALL videos
        $(slick.$slides).find('video').each(function () {
            this.pause();
            this.currentTime = 0;
            this.load();
        });
    }).slick({
        dots: true,
        adaptiveHeight: true,
        arrows: true,
        infinite: false,
        speed: 800,
        prevArrow: '<button class="slick-prev"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9567 26.1818C13.1753 26.1818 13.3989 26.0939 13.5666 25.9233C13.902 25.5821 13.902 25.0238 13.5666 24.6826L2.0862 13.0043L13.3989 1.49663C13.7343 1.15543 13.7343 0.597103 13.3989 0.255905C13.0635 -0.0852928 12.5146 -0.0852928 12.1792 0.255905L0.251563 12.384C-0.0838544 12.7252 -0.0838544 13.2835 0.251563 13.6247L12.3418 25.9233C12.5146 26.0991 12.7331 26.1818 12.9567 26.1818Z" fill="black"/></svg></button>',
        nextArrow: '<button class="slick-next"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.861432 26.1818C0.642902 26.1818 0.419266 26.0939 0.251556 25.9233C-0.0838604 25.5821 -0.0838604 25.0238 0.251556 24.6826L11.732 13.0043L0.419265 1.49663C0.083847 1.15543 0.083847 0.597103 0.419265 0.255905C0.754683 -0.0852928 1.30355 -0.0852928 1.63897 0.255905L13.5666 12.384C13.902 12.7252 13.902 13.2835 13.5666 13.6247L1.47634 25.9233C1.30355 26.0991 1.08504 26.1818 0.861432 26.1818Z" fill="black"/></svg></button>',
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.collection-testimonials-list').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button class="slick-prev"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9567 26.1818C13.1753 26.1818 13.3989 26.0939 13.5666 25.9233C13.902 25.5821 13.902 25.0238 13.5666 24.6826L2.0862 13.0043L13.3989 1.49663C13.7343 1.15543 13.7343 0.597103 13.3989 0.255905C13.0635 -0.0852928 12.5146 -0.0852928 12.1792 0.255905L0.251563 12.384C-0.0838544 12.7252 -0.0838544 13.2835 0.251563 13.6247L12.3418 25.9233C12.5146 26.0991 12.7331 26.1818 12.9567 26.1818Z" fill="black"/></svg></button>',
        nextArrow: '<button class="slick-next"><svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.861432 26.1818C0.642902 26.1818 0.419266 26.0939 0.251556 25.9233C-0.0838604 25.5821 -0.0838604 25.0238 0.251556 24.6826L11.732 13.0043L0.419265 1.49663C0.083847 1.15543 0.083847 0.597103 0.419265 0.255905C0.754683 -0.0852928 1.30355 -0.0852928 1.63897 0.255905L13.5666 12.384C13.902 12.7252 13.902 13.2835 13.5666 13.6247L1.47634 25.9233C1.30355 26.0991 1.08504 26.1818 0.861432 26.1818Z" fill="black"/></svg></button>',
        dots: false,
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });

    // FAQs
    $('.faqs-list').on('click', '.acc__title', function (e) {
        var accCard = $(this).closest('.acc__card');
        var accContainer = $(this).closest('.faqs-list');
        var accPanel = accCard.find('.acc__panel');
        var accTitle = $(this);
        var plusIcon = accTitle.find('.plus_icon');
        var minusIcon = accTitle.find('.minus_icon');

        if (accCard.hasClass('active_item')) {
            accCard.removeClass('active_item');
            accTitle.removeClass('active');
            accPanel.stop(true, true).slideUp();
            plusIcon.show();
        } else {
            accContainer.find('.acc__card').not(accCard).each(function () {
                $(this).removeClass('active_item')
                .find('.acc__panel').stop(true, true).slideUp().end()
                .find('.acc__title').removeClass('active')
                .find('.plus_icon').show().end();
            });

            accCard.addClass('active_item');
            accTitle.addClass('active');
            accPanel.stop(true, true).slideDown();
        }
    });

    // PDP Accordions
    $('.product-detail-sec').on('click', '.acc__title', function (e) {
        var accCard = $(this).closest('.acc__card');
        var accContainer = $(this).closest('.product-detail-sec');
        var accPanel = accCard.find('.acc__panel');
        var accTitle = $(this);
        var plusIcon = accTitle.find('.plus_icon');
        var minusIcon = accTitle.find('.minus_icon');

        if (accCard.hasClass('active_item')) {
            accCard.removeClass('active_item');
            accTitle.removeClass('active');
            accPanel.stop(true, true).slideUp();
            plusIcon.show();
        } else {
            accContainer.find('.acc__card').not(accCard).each(function () {
                $(this).removeClass('active_item')
                .find('.acc__panel').stop(true, true).slideUp().end()
                .find('.acc__title').removeClass('active')
                .find('.plus_icon').show().end();
            });

            accCard.addClass('active_item');
            accTitle.addClass('active');
            accPanel.stop(true, true).slideDown();
        }
    });

    // Tabbed FAQs
    var firstTab = $('.faq-tabs__nav li.active').data('tab');
    var firstFaq = $('#tab-' + firstTab).find('.faq-item').first();
    if (firstFaq.length) {
        firstFaq.addClass('active');
        firstFaq.find('.faq-answer').show();
    }

    $('.faq-tabs__nav li').on('click', function() {
        var tabId = $(this).data('tab');

        $('.faq-tabs__nav li').removeClass('active');
        $(this).addClass('active');

        $('.faq-tab').removeClass('active');
        $('#tab-' + tabId).addClass('active');

        $('.faq-answer').slideUp();
        $('.faq-item').removeClass('active');

        var firstFaq = $('#tab-' + tabId).find('.faq-item').first();
        if (firstFaq.length) {
            firstFaq.addClass('active');
            firstFaq.find('.faq-answer').slideDown();
        }
    });

    $('.faq-question').on('click', function() {
        var $this = $(this);
        var parent = $this.closest('.faq-tab');
        var faqItem = $this.closest('.faq-item');
        var answer = $this.next('.faq-answer');

        if (faqItem.hasClass('active')) {
            faqItem.removeClass('active');
            answer.slideUp();
        } else {
            parent.find('.faq-item').removeClass('active');
            parent.find('.faq-answer').slideUp();
            faqItem.addClass('active');
            answer.slideDown();
        }
    });

    $('.dynamic_checkout_box a').on('click', function (e) {
        e.preventDefault();
        var quantity = parseInt($('quantity-input input.quantity__input').val()) || 1;

        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');

        if (!variantId) {
            variantId = $('input.product-variant-id').val();
        }

        if (!variantId) {
            return;
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: quantity
            },
            dataType: 'json',
            success: function () {
                window.location.href = '/checkout';
            },
            error: function (error) {
                console.error(error);
            }
        });

    });

    $(".featured-product-variants").on("change", function(){
        var selopt = $(this).val();
        $(".featured-product-id").val(selopt);
    });

    $(".absorbency-guide").on("click", function(e){
        e.stopPropagation();
        $("body").addClass("absorbency-guide-open");
    });

    $(".size-chart-popup-txt").on("click", function(e){
        e.stopPropagation();
        $("body").addClass("size-chart-popup-open");
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.absorbency-guide-close').length) {
            $('body').removeClass('absorbency-guide-open');
            return;
        }

        if (!$(e.target).closest('.absorbency-guide-sec').length) {
            $('body').removeClass('absorbency-guide-open');
        }

    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.size-chart-popup-close').length) {
            $('body').removeClass('size-chart-popup-open');
            return;
        }

        if (!$(e.target).closest('.size-chart-popup-sec').length) {
            $('body').removeClass('size-chart-popup-open');
        }

    });

    function initHowItWorksSlider() {
        if ($(window).width() < 768) {
            if (!$('.how-it-works-list').hasClass('slick-initialized')) {
                $('.how-it-works-list').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: false,
                    autoplay: true
                });
            }
        } else {
            if ($('.how-it-works-list').hasClass('slick-initialized')) {
                $('.how-it-works-list').slick('unslick');
            }
        }
    }

    function initTrustBadge() {
        if ($(window).width() < 768) {
            if (!$('.trust-badges-list').hasClass('slick-initialized')) {
                $('.trust-badges-list').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: false,
                    autoplay: true
                });
            }
        } else {
            if ($('.trust-badges-list').hasClass('slick-initialized')) {
                $('.trust-badges-list').slick('unslick');
            }
        }
    }

    function initTrustList() {
        if ($(window).width() < 768) {
            if (!$('.why-trust-us-list').hasClass('slick-initialized')) {
                $('.why-trust-us-list').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: false,
                    autoplay: true
                });
            }
        } else {
            if ($('.why-trust-us-list').hasClass('slick-initialized')) {
                $('.why-trust-us-list').slick('unslick');
            }
        }
    }

    function initNewHereSlider() {
      if ($(window).width() <= 767) {
        if (!$('.new-here-list').hasClass('slick-initialized')) {
          $('.new-here-list').slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            adaptiveHeight: true
          });
        }
      } else {
        if ($('.new-here-list').hasClass('slick-initialized')) {
          $('.new-here-list').slick('unslick');
        }
      }
    }

    initHowItWorksSlider();
    initTrustBadge();
    initTrustList();
    initNewHereSlider();

    $(window).on('resize', initHowItWorksSlider);
    $(window).on('resize', initTrustBadge);
    $(window).on('resize', initTrustList);
    $(window).on('resize', initNewHereSlider);

});
